import { memo } from 'react';

import { Display } from '@/components/Display/Display';
import { Popover } from 'antd';

import MyIcon from '@/components/MyIcon';
import ActiveImg from './ActiveImg';
import './apart.scss';
const RenderList = ({ list, onClick, curToolId }) => {
    return list.map((item, index) => {
        return (
            <div className={'list-item'} data-active={curToolId === item.id} key={index} onClick={() => onClick(item)}>
                <span className="skill-name">
                    <MyIcon className="skill-icon" type="icon-a-yinpin"></MyIcon>
                    {item.name}
                </span>
                <Display show={curToolId === item.id}>
                    <ActiveImg></ActiveImg>
                </Display>
            </div>
        );
    });
};
// const toolList = [
//     {
//         title: '音视频转录',
//         id: '1'
//     }
// ];
const ToolList = (props) => {
    const { toolList = [], chatBoxRef } = props;
    const onClick = (data) => {
        props.changeTool(data);
    };
    return (
        <div className={'left-skill-box'}>
            <Display show={toolList.length}>
                <Popover
                    getPopupContainer={() => {
                        return chatBoxRef.current;
                    }}
                    arrow={false}
                    rootClassName="more-skill-box"
                    placement="right"
                    content={<RenderList onClick={onClick} curToolId={props?.curToolId} list={toolList}></RenderList>}
                    // open={open}
                    trigger="hover"
                >
                    <div data-more="true" className={'list-item'}>
                        <span className={'more-item'}>
                            <MyIcon className="skill-icon" type="icon-gongju"></MyIcon>
                            工具
                        </span>
                        <MyIcon style={{ color: '#999999' }} type="icon-right"></MyIcon>
                        {/* {expand ? <DownOutlined /> : <RightOutlined />} */}
                    </div>
                </Popover>
            </Display>
        </div>
    );
};
export default memo(ToolList);
